<template>
  <v-container fluid class="pa-0">
    <!-- Header Card -->
    <v-card class="mb-4">
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <span class="text-h5">Campañas WhatsApp</span>
          <v-chip small class="ml-2" color="success" text-color="white">
            Conectado
          </v-chip>
        </div>
      </v-card-title>
    </v-card>

    <!-- Dashboard Stats -->
    <v-row class="mb-4">
      <v-col cols="12" md="4">
        <v-card class="stat-card">
          <v-card-text>
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline mb-1">Mensajes Hoy</div>
                <div class="text-h4">{{ campaigns.length }}</div>
              </div>
              <v-icon x-large color="primary" class="stat-icon">mdi-message-text</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="stat-card">
          <v-card-text>
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline mb-1">Tasa de Éxito</div>
                <div class="text-h4">98%</div>
              </div>
              <v-icon x-large color="success" class="stat-icon">mdi-check-circle</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="stat-card">
          <v-card-text>
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline mb-1">Plantillas Activas</div>
                <div class="text-h4">{{ campaigns.length }}</div>
              </div>
              <v-icon x-large color="info" class="stat-icon">mdi-file-document</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Main Campaigns Card -->
    <v-card>
      <v-toolbar flat class="campaigns-toolbar">
        <v-toolbar-title class="font-weight-medium">Plantillas</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar plantillas" single-line hide-details
          dense outlined class="mx-2" style="max-width: 300px"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="dialog = true">
          <v-icon left>mdi-plus</v-icon>
          Nueva Plantilla
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-6">
        <v-row>
          <v-col v-for="campaign in filteredCampaigns" :key="campaign.name" cols="12" md="6" lg="4">
            <v-card outlined hover class="campaign-card">
              <v-card-title class="campaign-header py-2 px-4">
                <div class="d-flex justify-space-between align-center w-100">
                  <div class="text-truncate">{{ campaign.name }}</div>
                  <div class="actions">
                    <v-btn icon x-small class="mr-1" @click.stop="editItem(campaign)">
                      <v-icon size="18">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon x-small @click.stop="deleteItem(campaign)">
                      <v-icon size="18">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-card-title>

              <v-card-text class="pa-4">
                <div class="campaign-content grey lighten-4 rounded pa-3">
                  <div class="text-body-2" style="white-space: pre-wrap;">{{ campaign.content }}</div>
                </div>

                <div class="d-flex justify-space-between align-center mt-4">
                  <div class="text-caption grey--text">
                    <v-icon small class="mr-1">mdi-clock-outline</v-icon>
                    {{ campaign.lastRun ? `Última ejecución: ${campaign.lastRun}` : 'Sin ejecutar' }}
                  </div>
                  <v-btn color="primary" outlined small @click.stop="showMessageModal(campaign)" class="launch-btn">
                    Lanzar Campaña
                    <v-icon right small>mdi-send</v-icon>
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- New/Edit Campaign Modal -->
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline">{{ formTitle }}</v-card-title>
        <v-form ref="form" v-model="valid">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="campaignModel.name" label="Nombre*" :rules="[rules.required]"
                    outlined></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="campaignModel.content" label="Contenido del Mensaje*" :rules="[rules.required]"
                    hint="Usa {nombre} para insertar el nombre del destinatario" persistent-hint outlined
                    auto-grow></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeDialog">Cerrar</v-btn>
            <v-btn color="primary" text @click="save" :disabled="!valid">Guardar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Message Send Modal -->
    <v-dialog v-model="messageModal" persistent max-width="1200px">
      <v-card>
        <v-card-title class="headline d-flex justify-space-between align-center">
          <span>{{ campaignModel.name }}</span>
          <v-btn icon @click="closeMessageModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <!-- Message Configuration -->
              <v-col cols="12" md="6">
                <v-card outlined>
                  <v-card-text>
                    <v-textarea v-model="campaignModel.content" label="Mensaje" outlined auto-grow></v-textarea>

                    <v-switch v-model="isSingleMessage" label="Enviar mensaje único" class="mt-0"></v-switch>
                    <!-- Nuevo Combobox para etiquetas -->
                    <v-combobox v-if="showLabels" v-model="selectedLabels" :items="labels" item-text="name"
                      item-value="id" label="Seleccionar etiquetas" multiple chips outlined class="mt-4">
                      <template v-slot:selection="{ item }">
                        <v-chip :color="item.colorHex" text-color="white" small class="mr-1">
                          {{ item.name }}
                        </v-chip>
                      </template>
                    </v-combobox>

                    <v-text-field v-if="isSingleMessage" v-model="phone" :rules="[rules.required]" v-mask="mask"
                      label="Número de Teléfono" hint="Formato: 8094445555" persistent-hint outlined></v-text-field>

                    <v-file-input v-model="file" accept="image/*" label="Adjuntar Imagen" prepend-icon="mdi-camera"
                      class="mt-4" outlined></v-file-input>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Recipients List -->
              <v-col cols="12" md="6">
                <v-card outlined>
                  <v-card-title class="d-flex justify-space-between align-center">
                    <span>Destinatarios ({{ filteredClients.length }})</span>
                    <div class="d-flex">
                      <v-btn v-if="!isSingleMessage" icon class="mr-2" @click="showfilterClientsModal">
                        <v-icon>mdi-filter</v-icon>
                      </v-btn>
                      <v-btn v-if="!isSingleMessage" icon color="success" @click="uploadModal = true"
                        >
                        <v-icon>mdi-file-excel</v-icon>
                      </v-btn>
                    </div>
                  </v-card-title>

                  <v-card-text>
                    <v-list v-if="!isSingleMessage" height="300" class="overflow-y-auto">
                      <v-list-item v-for="client in filteredClients" :key="client.id">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ client.name }} - {{ client.phone }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-icon v-if="client.isSent" color="success" small>
                            mdi-check-circle
                          </v-icon>
                          <v-icon v-if="client.hasError" color="error" small>
                            mdi-alert-circle
                          </v-icon>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-card-text>

                  <v-card-actions class="pa-4">
                    <v-btn block color="primary" :loading="loadingSendBtn" @click="sendMessage"
                      :disabled="!isValidToSend">
                      <v-icon left>mdi-send</v-icon>
                      Enviar Campaña
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Filter Recipients Modal -->
    <v-dialog v-model="filterClientsModal" max-width="500">
      <v-card>
        <v-card-title>Filtrar Destinatarios</v-card-title>
        <v-card-text>
          <v-textarea v-model="clientsIds" label="IDs de Destinatarios" hint="Ingrese los IDs (uno por línea)"
            persistent-hint outlined></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="filterClientsModal = false">Cancelar</v-btn>
          <v-btn color="primary" @click="getClientsByIds">Aplicar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Upload Excel Modal -->
    <v-dialog v-model="uploadModal" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Cargar Archivo Excel</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-file-input v-model="excelFile" label="Telefono, Nombre, etc."></v-file-input>
            </v-row>
            <v-row>
              <v-btn @click="UploadReceivers()" color="orange" dark>
                <v-icon left>mdi-cloud-upload</v-icon>Cargar
              </v-btn>
              <v-btn class="mx-2" @click="downloadTemplate()" color="green" dark>
                <v-icon left>mdi-download</v-icon>Descargar Plantilla
              </v-btn>
              <v-btn class="mx-3" @click="hideUploadModal()" color="blue darken-1" text>Cancelar</v-btn>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Phone Number Dialog -->
    <v-dialog v-model="showPhoneNumberDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Ingrese el número de teléfono al cual notificar el resultado de la campaña</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="notificationPhoneNumber" label="Número de teléfono" required></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="showPhoneNumberDialog = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="confirmPhoneNumber">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mask } from 'vue-the-mask'
import {
  getFirestore,
  doc,
  updateDoc,
  getDoc,
  getDocs,
  setDoc,
  deleteDoc,
  collection,
  increment
} from "firebase/firestore"
import { getAuth, onAuthStateChanged } from "firebase/auth"
import { firebaseApp } from "../../firebase"
import CampaignModel from "../../models/CampaignModel"
import axios from "axios"
import * as XLSX from 'xlsx'
import { buildApiUrl, getAuthHeaders } from "../../config/api"

const auth = getAuth()
const db = getFirestore(firebaseApp)
const branchesRef = collection(db, "branches")
const {
  phoneNumberFormatter
} = require("../../helpers/formatter");

export default {
  name: 'WhatsappCampaigns',

  directives: {
    mask
  },

  data: () => ({
    valid: true,
    campaigns: [],
    search: "",
    dialog: false,
    messageModal: false,
    filterClientsModal: false,
    mask: "##########",
    editedIndex: -1,
    campaignModel: new CampaignModel(),
    loadingSendBtn: false,
    file: null,
    clients: [],
    filteredClients: [],
    isSingleMessage: false,
    clientsIds: "",
    phone: "",
    url: "",
    uid: null,
    currentBranch: null,
    rules: {
      required: v => !!v || 'Este campo es requerido'
    },
    excelFile: null,
    processedClients: [],
    processingExcel: false,
    excelError: null,
    uploadModal: false,
    loadingUploadBtn: false,
    disableUploadBtn: false,
    labels: [],
    selectedLabels: [],
    showLabels: false,
    selectedSendMethod: 'sendWSMessageProcessServer',
    notificationPhoneNumber: '8096019002',
    showPhoneNumberDialog: false,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Plantilla" : "Editar Plantilla"
    },

    filteredCampaigns() {
      return this.campaigns.filter(campaign =>
        campaign.name.toLowerCase().includes(this.search.toLowerCase()) ||
        campaign.content.toLowerCase().includes(this.search.toLowerCase())
      )
    },

    isValidToSend() {
      if (this.isSingleMessage) {
        return this.phone && this.campaignModel.content
      }
      return this.filteredClients.length > 0 && this.campaignModel.content
    },

    selectedBranch() {
      return this.$store.state.selectedBranch
    }
  },

  watch: {
    selectedBranch(newValue) {
      this.currentBranch = newValue
      this.getServerURL(this.currentBranch)
      this.getCampaigns()
      this.clients = []
      this.clientsIds = []
    },

    dialog(val) {
      val || this.closeDialog()
    }
  },

  created() {
    this.currentBranch = this.$store.state.selectedBranch
    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.uid = user.uid
        // Fetch user's notification phone number
        this.fetchUserNotificationNumber(user.uid)
      }
    })
    this.getServerURL(this.currentBranch)
    this.getCampaigns();

  },

  methods: {
    async fetchUserNotificationNumber(uid) {
      try {
        const userRef = doc(db, "users", uid)
        const userSnap = await getDoc(userRef)
        if (userSnap.exists() && userSnap.data().notificationPhoneNumber) {
          this.notificationPhoneNumber = userSnap.data().notificationPhoneNumber
        }
      } catch (error) {
        console.error('Error fetching notification phone number:', error)
      }
    },

    async getServerURL(branch) {
      const branchRef = doc(db, "branches", branch)
      const branchSnap = await getDoc(branchRef)
      if (branchSnap.exists()) {
        this.url = branchSnap.data().server
      } else {
        console.log("No such document!")
      }
    },

    async getLabels() {
      try {
        const response = await axios.get(
          this.url + "api/" + this.currentBranch + "/labels",
          {
            headers: {
              'X-Api-Key': '74d3d906-acd4-4702-bfef-5bcc3482a292',
            },
          }
        )
        this.labels = response.data

      } catch (error) {
        console.error('Error al obtener etiquetas:', error)
        //this.displayNotification('error', 'Error al cargar las etiquetas')
      }
    },

    async getCampaigns() {
      this.loadingtable = true
      this.campaigns = []

      try {
        const querySnapshot = await getDocs(
          collection(db, "branches/" + this.currentBranch + "/campaigns")
        )
        querySnapshot.forEach((doc) => {
          this.campaigns.push({
            name: doc.data().name,
            content: doc.data().content,
            lastRun: doc.data().lastRun,
          })
        })
      } catch (error) {
        this.displayNotification("error", "Error al cargar las campañas")
        console.error(error)
      } finally {
        this.loadingtable = false
        this.sortCampaignsByLastRun()
      }
    },

    sortCampaignsByLastRun() {
      this.campaigns.sort((a, b) => {
        const dateA = a.lastRun ? this.convertToDate(a.lastRun) : new Date(0) // Min date for null values
        const dateB = b.lastRun ? this.convertToDate(b.lastRun) : new Date(0) // Min date for null values
        return dateB - dateA
      })
    },

    convertToDate(dateStr) {
      const [day, month, year] = dateStr.split('/')
      return new Date(`${year}-${month}-${day}`)
    },

    async getClients() {
      try {
        const querySnapshot = await getDocs(
          collection(db, "branches/" + this.currentBranch + "/clients")
        )
        this.clients = []
        querySnapshot.forEach((doc) => {
          this.clients.push({
            id: doc.data().id,
            name: doc.data().name,
            phone: doc.data().phone,
            isSent: false,
            hasError: false,
            successfulCount: doc.data().successfulCount,
            failCount: doc.data().failCount
          })
        })
      } catch (error) {
        this.displayNotification("error", "Error al cargar los clientes")
        console.error(error)
      }
    },

    async getClientsByIds() {
      this.filterClientsModal = false
      let clientsIdsArray;
      clientsIdsArray = this.clientsIds.split("\n");
      clientsIdsArray = [...new Set(clientsIdsArray)];
      clientsIdsArray = clientsIdsArray.map((x) => x.split(" ")[0]);
      clientsIdsArray = clientsIdsArray.filter(function (el) {
        return el != "";
      });
      if (this.clients.length === 0) {
        await this.getClients()
      }

      this.filteredClients = this.clients.filter((client) =>
        clientsIdsArray.includes(client.id)
      )
    },

    editItem(item) {
      this.editedIndex = this.campaigns.indexOf(item)
      this.campaignModel = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      this.$swal.fire({
        title: "¿Está seguro de eliminar esta plantilla?",
        text: "Esta acción no se puede deshacer",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar"
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteDoc(
              doc(db, "branches", this.currentBranch, "campaigns", item.name)
            )
            this.closeDialog()
            await this.getCampaigns()
            this.displayNotification("success", "Plantilla eliminada correctamente")
          } catch (error) {
            this.displayNotification("error", "Error al eliminar la plantilla")
            console.error(error)
          }
        }
      })
    },

    async save() {
      if (this.$refs.form.validate()) {
        try {
          await setDoc(
            doc(
              db,
              "branches",
              this.currentBranch,
              "campaigns",
              this.campaignModel.name
            ),
            {
              name: this.campaignModel.name,
              content: this.campaignModel.content,
            }
          )
          this.closeDialog()
          await this.getCampaigns()
          this.displayNotification("success", "Plantilla guardada correctamente")
        } catch (error) {
          this.displayNotification("error", "Error al guardar la plantilla")
          console.error(error)
        }
      }
    },

    async sendMessage() {
      const result = await this.$swal.fire({
        title: "¿Está seguro de enviar esta campaña?",
        text: "Esta acción no se puede deshacer",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sí, enviar",
        cancelButtonText: "Cancelar"
      })

      if (result.value) {
        //this.sendWSMessage()
        // this.sendWSMessageProcessServer();
        this.loadingSendBtn = true;
        try {
          if (this.selectedSendMethod === 'sendWSMessageProcessServer') {
            //this.showPhoneNumberDialog = true;
            await this.confirmPhoneNumber();
          } else {
            await this[this.selectedSendMethod]();
            this.displayNotification("success", "Campaña enviada correctamente");
          }
        } catch (error) {
          this.displayNotification("error", "Error al enviar los mensajes");
          console.error(error);
        } finally {
          this.loadingSendBtn = false;
          this.sortCampaignsByLastRun();
        }
      }
    },

    async confirmPhoneNumber() {
      try {
        //this.showPhoneNumberDialog = false
        this.sendWSMessageProcessServer()
      } catch (error) {
        console.error('Error updating notification phone number:', error)
        this.displayNotification("error", "Error al guardar el número de teléfono")
      }
    },

    async sendWSMessageProcessServer() {
      try {
        this.loadingSendBtn = true
        const campaignRef = doc(db, `branches/${this.currentBranch}/campaigns/${this.campaignModel.name}`)
        const currentDate = this.getCurrentDateInGMTMinus4()

        const messagesToSend = this.isSingleMessage
          ? [{
            id: "",
            name: "",
            phone: this.phone,
            isSent: false,
            hasError: false,
          }]
          : [...this.filteredClients]
        const requests = [];
        for (let i = 0; i < messagesToSend.length; i++) {
          const client = messagesToSend[i]

          if (!client.phone || client.phone.trim() === "") {
            continue;
          }

          const message = this.prepareSendWSMessage(client)

          requests.push(
            {
              chatId: `1${client.phone}@c.us`,
              text: message,
              session: this.currentBranch,
              linkPreview: true,
              labels: this.selectedLabels.map(label => ({ id: label.id })),
              campaign: this.campaignModel.name
            }
          );
        }

        const notiPhoneNumber = `1${this.notificationPhoneNumber}@c.us`

        const response = await axios.post(
          buildApiUrl('/sendText', {
            'Notification-Phone-Number': notiPhoneNumber
          }),
          requests,
          {
            headers: getAuthHeaders(),
          }
        );

        const jobId = response.data.jobId;

        // Actualizar lastRun de la campaña
        await updateDoc(campaignRef, {
          lastRun: currentDate,
          jobId: jobId
        })

        // Actualizar el estado local de la campaña
        const campaignIndex = this.campaigns.findIndex(c => c.name === this.campaignModel.name)
        if (campaignIndex !== -1) {
          this.campaigns[campaignIndex].lastRun = currentDate
        }

        this.displayNotification("success", "Campaña enviada correctamente")
        this.closeMessageModal();

      } catch (error) {
        this.displayNotification("error", "Error al enviar los mensajes")
        console.error(error)
      } finally {
        this.loadingSendBtn = false
        this.sortCampaignsByLastRun()
      }
    },

    prepareSendWSMessage(client) {
      let message = this.campaignModel.content;

      // Encontrar todas las variables entre brackets
      const variables = message.match(/\{([^}]+)\}/g) || [];

      variables.forEach(variable => {
        const cleanVariable = variable.replace(/[{}]/g, '').toLowerCase();

        var value = client[cleanVariable] || '';

        if (value == "" && cleanVariable == "nombre") {
          value = client.name || "";
        }

        if (value !== "") {
          message = message.replace(variable, value);
        }
      });

      return message;
    },

    async showMessageModal(item) {
      this.campaignModel = { ...item }
      this.filteredClients = []
      this.phone = ""
      this.isSingleMessage = false
      this.messageModal = true
      await this.getLabels()
      if (this.labels.length > 0) {

        this.showLabels = true
      }
    },

    closeDialog() {
      this.dialog = false
      this.$nextTick(() => {
        this.$refs.form.reset()
        this.campaignModel = new CampaignModel()
        this.editedIndex = -1
      })
    },

    closeMessageModal() {
      this.messageModal = false
      this.campaignModel = new CampaignModel()
      this.filteredClients = []
      this.phone = ""
      this.file = null
      this.selectedLabels = []
    },

    displayNotification(type, message) {
      this.$swal.fire({
        position: "top-end",
        type: type,
        title: message,
        showConfirmButton: false,
        timer: 3000,
        toast: true
      })
    },

    getCurrentDateInGMTMinus4() {
      const options = {
        timeZone: 'America/Santo_Domingo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }
      const formatter = new Intl.DateTimeFormat('es-DO', options)
      const parts = formatter.formatToParts(new Date())
      const date = parts.reduce((acc, part) => {
        if (part.type !== 'literal') {
          acc[part.type] = part.value
        }
        return acc
      }, {})
      return `${date.day}/${date.month}/${date.year}`
    },

    showfilterClientsModal() {
      this.filterClientsModal = true;
    },

    hideUploadModal() {
      this.uploadModal = false;
      this.excelFile = null;
    },

    async UploadReceivers() {
      if (this.excelFile == null) {
        this.displayNotification(
          "error",
          "El archivo es de un formato incorrecto o no se ha cargado."
        );
        return;
      }
      this.loadingUploadBtn = true;
      this.uploadModal = false;
      try {
        const jsonData = await this.readExcelFile(this.excelFile)
        if (jsonData.length < 2) { // Verificar que haya al menos encabezados y una fila
          throw new Error("El archivo Excel está vacío o no tiene el formato correcto")
        }

        const headers = jsonData[0]
        const processedData = this.processExcelData(jsonData.slice(1), headers)

        console.log(processedData);

        // Validar que los datos procesados tengan al menos un teléfono
        if (processedData.length === 0) {
          throw new Error("No se encontraron datos válidos en el archivo Excel")
        }

        this.filteredClients = processedData.map((client, index) => ({
          id: client.id || `${String(Math.random()).slice(2, 8)}_${index}`,
          name: `${client.nombre || client.name || client.nombres || client.firstname || ''} ${client.apellido || client.lastname || client.appellidos || ''}`.trim(),
          phone: phoneNumberFormatter(client.telefono || client.celular || client.phone || client.cel || client.telcelular || ''),
          isSent: false,
          hasError: false,
          ...client,
          uniqueKey: `${index}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
        })).filter(client =>
          client.phone &&
          this.isValidPhoneNumber(client.phone) &&
          client.name
        )
        this.displayNotification(
          "success",
          `Se procesaron ${this.filteredClients.length} contactos correctamente`
        )

        // Cerrar modal de filtro si está abierto
        this.filterClientsModal = false
      } catch (error) {
        console.error('Error processing Excel:', error)
        this.excelError = error.message
        this.displayNotification("error", `Error al procesar el archivo: ${error.message}`)
      } finally {
        this.processingExcel = false
        this.excelFile = null
      }
    },

    async readExcelFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result)
            const workbook = XLSX.read(data, { type: 'array' })

            if (workbook.SheetNames.length === 0) {
              reject(new Error("El archivo Excel no contiene hojas"))
              return
            }

            const sheetName = workbook.SheetNames[0]
            const sheet = workbook.Sheets[sheetName]
            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 })
            resolve(jsonData)
          } catch (error) {
            reject(new Error("Error al leer el archivo Excel"))
          }
        }

        reader.onerror = () => reject(new Error("Error al leer el archivo"))
        reader.readAsArrayBuffer(file)
      })
    },

    processExcelData(rows, headers) {
      // Encontrar todas las variables entre brackets en el contenido del mensaje
      const bracketVariables = (this.campaignModel.content.match(/\{([^}]+)\}/g) || [])
        .map(v => v.replace(/[{}]/g, '').toLowerCase());

      return rows.map(row => {
        const obj = {};
        headers.forEach((header, index) => {
          if (header && row[index] !== undefined) {
            // Convertir encabezado a minúsculas y eliminar espacios/caracteres especiales
            const key = header.toString()
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .replace(/[^a-z0-9]/g, "");

            // Guardar el valor si el encabezado coincide con una variable entre brackets
            if (bracketVariables.includes(key)) {
              obj[key] = row[index];
            }

            // Guardar también los campos básicos necesarios
            if (['id', 'codigo', 'nombre', 'name', 'nombres', 'firstname', 'apellido', 'lastname', 'phone', 'telefono', 'celular', 'telcelular', 'cel', 'tel'].includes(key)) {
              obj[key] = row[index];
            }
          }
        });
        return obj;
      });
    },
    isValidPhoneNumber(phone) {
      return phone.length === 10 && /^\d+$/.test(phone)
    },
    downloadTemplate() {
      try {
        // Crear la estructura de datos para la plantilla
        const headers = ['id', 'nombre', 'apellido', 'telefono', 'email', 'ciudad', 'direccion'];
        const exampleRow = ['C001', 'Juan', 'Pérez', '8091234567', 'correo@ejemplo.com', 'Santo Domingo', 'Calle Principal #123'];
        
        // Crear un libro de trabajo
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet([headers, exampleRow]);
        
        // Agregar la hoja al libro
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Destinatarios');
        
        // Generar el archivo para descarga
        XLSX.writeFile(workbook, 'plantilla_receptores.xlsx');
        
        this.displayNotification("success", "Plantilla descargada correctamente");
      } catch (error) {
        console.error('Error al descargar plantilla:', error);
        this.displayNotification("error", "Error al descargar la plantilla");
      }
    },
  }
}
</script>

<style scoped>
.stat-card {
  transition: transform 0.2s;
}

.stat-card:hover {
  transform: translateY(-2px);
}

.stat-icon {
  opacity: 0.8;
  background: rgba(var(--v-primary-base), 0.1);
  padding: 8px;
  border-radius: 8px;
}

.campaign-card {
  transition: all 0.2s ease;
  border: 1px solid #e0e0e0 !important;
}

.campaign-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08) !important;
}

.campaign-header {
  border-bottom: 1px solid #f0f0f0;
  background-color: #fafafa;
}

.campaign-content {
  max-height: 120px;
  overflow-y: auto;
  border: 1px solid #eeeeee;
}

.actions {
  opacity: 0.7;
  transition: opacity 0.2s;
}

.campaign-card:hover .actions {
  opacity: 1;
}

.launch-btn {
  text-transform: none;
}

.campaigns-toolbar {
  border-bottom: 1px solid #e0e0e0;
}
</style>